<ng-container *ngIf="vm$ | async as vm">

  <div class="wd-container" [ngClass]="classCss">

    <div *ngIf="showLabel" class="week">Week</div>

    <div class="move">

      <div class="move-back" (click)="onChangeDate(MoveType.Back)">
        <i class="fa fa-chevron-left"></i>
      </div>

      <div class="date txt-gray">
        {{$safeNavigationMigration(vm?.monday) | dateTimeFormat:$safeNavigationMigration(vm?.timezone):$safeNavigationMigration(vm?.dateFormat)}} - {{$safeNavigationMigration(vm?.sunday) | dateTimeFormat:$safeNavigationMigration(vm?.timezone):$safeNavigationMigration(vm?.dateFormat)}}
      </div>

      <div class="move-next" (click)="onChangeDate(MoveType.Forward)">
        <i class="fa fa-chevron-right"></i>
      </div>
    </div>


    <div class="today ml-20 txt-gray" (click)="onChangeDate(MoveType.Today)">
      Today
    </div>

    <div class="picker ml-5">
      <luxon-calendar [styleIcon]="styleIconCalendar" [showInput]="false" [showIcon]="true" [showZone]="false" [formControl]="selectedDate" appendTo="body"></luxon-calendar>
    </div>

  </div>

</ng-container>